isSupplementaryCodePoint